<!-- Heading -->
<eds-title
  *ngIf="relatedStrategies?.heading"
  [title]="relatedStrategies.heading"
  size="h2"
  theme="primary"
  edsSpacing="xs"
></eds-title>

<!-- Summary -->
<div class="ck-editor" *ngIf="relatedStrategies?.summary">
  <div [innerHTML]="relatedStrategies.summary"></div>
</div>

<!-- Tabs -->
<eds-tabs
  *ngIf="relatedStrategies.tabs"
  edsCol
  [followFocus]="true"
  [isNavigation]="false"
  [cacheActive]="true"
  [fullWidth]="true"
>
  <ng-container *ngFor="let tab of relatedStrategies.tabs; let i = index">
    <eds-tab [heading]="tab.tabLabel">
      <ng-container brComponent="tab-area-{{ i + 1 }}">
        <div [innerHTML]="tab.introParagraph?.value"></div>
        <!-- tab internal content -->
        <div [innerHTML]="tab.processedContent"></div>
      </ng-container>
    </eds-tab>
  </ng-container>
</eds-tabs>
